import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// -------- Case & game --------
export const fetchToday = async (discipline) => {
  const q = discipline ? `?discipline=${encodeURIComponent(discipline)}` : "";
  return (await api.get(`/case/today${q}`)).data;
};
export const fetchCaseById = async (caseId) =>
  (await api.get(`/case/${caseId}`)).data;

export const fetchDisciplines = async () => (await api.get("/disciplines")).data;

export const fetchVersion = async () => (await api.get("/version")).data;

export const submitGuess = async (case_id, question_id) =>
  (await api.post("/case/guess", { case_id, question_id })).data;

export const submitDiagnosis = async (case_id, diagnosis) =>
  (await api.post("/case/submit", { case_id, diagnosis })).data;

// -------- Archive --------
export const fetchArchive = async (params = {}) => {
  const search = new URLSearchParams();
  if (params.specialty) search.set("specialty", params.specialty);
  if (params.difficulty) search.set("difficulty", params.difficulty);
  const qs = search.toString() ? `?${search.toString()}` : "";
  return (await api.get(`/archive${qs}`)).data;
};

// -------- Auth --------
export const fetchMe = async () => {
  try {
    return (await api.get("/auth/me")).data;
  } catch {
    return null;
  }
};

export const fetchStatsMe = async () => (await api.get("/stats/me")).data;

export const syncStats = async (payload) =>
  (await api.post("/stats/sync", payload)).data;

export const exchangeSession = async (session_id) =>
  (await api.post("/auth/session", { session_id })).data;

export const logout = async () => (await api.post("/auth/logout")).data;

// -------- Admin --------
const adminHeaders = (token) => ({ headers: { "X-Admin-Token": token } });

export const adminVerify = async (token) =>
  (await api.post("/admin/verify", {}, adminHeaders(token))).data;

export const adminList = async (token) =>
  (await api.get("/admin/cases", adminHeaders(token))).data;

export const adminGet = async (token, caseId) =>
  (await api.get(`/admin/cases/${caseId}`, adminHeaders(token))).data;

export const adminCreate = async (token, payload) =>
  (await api.post("/admin/cases", payload, adminHeaders(token))).data;

export const adminUpdate = async (token, caseId, payload) =>
  (await api.put(`/admin/cases/${caseId}`, payload, adminHeaders(token))).data;

export const adminDelete = async (token, caseId) =>
  (await api.delete(`/admin/cases/${caseId}`, adminHeaders(token))).data;

export const adminBatchGenerate = async (token, payload) =>
  (await api.post("/admin/batch-generate", payload, { ...adminHeaders(token), timeout: 900000 })).data;

export const adminSchedulerStatus = async (token) =>
  (await api.get("/admin/scheduler-status", adminHeaders(token))).data;

export const adminSchedulerRunNow = async (token) =>
  (await api.post("/admin/scheduler-run-now", {}, { ...adminHeaders(token), timeout: 900000 })).data;

export const adminAnalytics = async (token, days = 14) =>
  (await api.get(`/admin/analytics?days=${days}`, adminHeaders(token))).data;
